import { PackStatusRequestImpl } from "../../../core/api/packstatus/packstatusrequest";
import { PackStatusResponse } from "../../../core/api/packstatus/packstatusresponse";
import { DeleteToneRequestImpl } from "../../../core/api/tune/deletetone/deletetonerequest";
import { DeleteToneResponse } from "../../../core/api/tune/deletetone/deletetoneresponse";
import { DeleteToneDtoImpl } from "../../../core/dto/deletetone/deletetonedto";
import { PackStatusDtoImpl } from "../../../core/dto/packstatus/packstatusdto";
import { MyAccountProcessorFactory } from "../../../core/processorfactory/myaccountprocessorfactory";
import { BaseContext } from "../../../utils/basecontext";
import { APIModel, APIModelImpl, APIModelHandler } from "../uicomponentapimodel";

export interface FooterAPIModel extends APIModel
{
   
    getPackStatusAPI(): void;
    unsubscribeUser(): void;
}

export class FooterAPIModelImpl extends APIModelImpl implements FooterAPIModel
{
    private myAccountProcessor: MyAccountProcessorFactory;
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
        this.myAccountProcessor = this.getAPIProcesssorFactory().getMyAccountProcessorFactory();
    }

   
   

    

    unsubscribeUser(): void 
    {
      let deleteToneDto = new DeleteToneDtoImpl();
            deleteToneDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
            deleteToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
            deleteToneDto.setToneId("");
            deleteToneDto.setPackName(this.getContext().getUserContext().getPackName());
             console.log("---tiger"+deleteToneDto.getPackName());
            this.getAPIProcesssorFactory().getToneProcessorFactory()
            .getDelteTone()
            .success((deleteToneResponse: DeleteToneResponse)=>
            {
                this.getAPIModelHandler().onSuccess(deleteToneResponse.getAPIFeature(), 
                deleteToneResponse.getDescription(), deleteToneResponse);
              
              })
            .failure((deleteToneResponse: DeleteToneResponse)=>
              {
                this.getAPIModelHandler().onFailure(deleteToneResponse.getAPIFeature(), 
                deleteToneResponse.getDescription(), undefined);
              })
            .execute(new DeleteToneRequestImpl(deleteToneDto));    
    }
    
   
    getPackStatusAPI(): void 
     { 
             console.log("packStatusAPI() invoked");
             let packStatusDto = new PackStatusDtoImpl();
             packStatusDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
    
             this.myAccountProcessor.getPackStatus()
             .success((packStatusResponse: PackStatusResponse)=>
             {
                 console.log("packStatusAPI success invoked"+packStatusResponse.getAPIFeature());
                 this.getAPIModelHandler().onSuccess(packStatusResponse.getAPIFeature(), 
                 packStatusResponse.getDescription(), packStatusResponse.getPackStatusDto());
               
              })
             .failure((packStatusResponse: PackStatusResponse)=>
              {
                this.getAPIModelHandler().onFailure(packStatusResponse.getAPIFeature(), 
                packStatusResponse.getDescription(), undefined);
              })
             .execute(new PackStatusRequestImpl(packStatusDto));
     } 

   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/footer-native/footerapimodel.ts